import './styles.scss'

interface AnimatedLogoProps {
  widthAndHeight: Record<'width' | 'height', string>
  colors: Array<string>
}

export default function AnimatedLogo({
  widthAndHeight,
  colors,
}: AnimatedLogoProps) {
  return (
    <svg
      id="animated-logo"
      viewBox="0 0 94 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...widthAndHeight}
    >
      <g id="integra-animated">
        <g id="center">
          <path
            id="curveLeft"
            d="M52.0976 57.8702C31.1279 57.8702 21.5762 47.7946 21.5762 38.4351C21.5762 29.0756 31.1279 19 52.0976 19C54.2367 19 55.9728 20.7361 55.9728 22.8752C55.9728 25.0144 54.2367 26.7505 52.0976 26.7505C37.1484 26.7505 29.3267 32.6284 29.3267 38.4351C29.3267 44.2418 37.1484 50.1197 52.0976 50.1197C54.2367 50.1197 55.9728 51.8558 55.9728 53.995C55.9728 56.1341 54.2367 57.8702 52.0976 57.8702Z"
            fill={colors[1]}
          />
          <path
            id="curveRight"
            d="M41.6999 73.4303C39.5608 73.4303 37.8247 71.6942 37.8247 69.555C37.8247 67.4159 39.5608 65.6798 41.6999 65.6798C56.6491 65.6798 64.4709 59.8018 64.4709 53.9952C64.4709 48.1885 56.6491 42.3105 41.6999 42.3105C39.5608 42.3105 37.8247 40.5744 37.8247 38.4353C37.8247 36.2962 39.5608 34.5601 41.6999 34.5601C62.6696 34.5601 72.2213 44.6357 72.2213 53.9952C72.2213 63.3546 62.6696 73.4303 41.6999 73.4303Z"
            fill={colors[0]}
          />
        </g>
        <g id="balls">
          <path
            id="ballLeft"
            d="M15.4008 38.435C15.4008 41.8607 12.6261 44.6354 9.20038 44.6354C5.77467 44.6354 3 41.8607 3 38.435C3 35.0093 5.77467 32.2346 9.20038 32.2346C12.6261 32.2346 15.4008 35.0093 15.4008 38.435Z"
            fill={colors[1]}
          />
          <path
            id="ballRight"
            d="M90.5556 53.9948C90.5556 50.5691 87.7809 47.7944 84.3552 47.7944C80.9295 47.7944 78.1548 50.5691 78.1548 53.9948C78.1548 57.4205 80.9295 60.1952 84.3552 60.1952C87.7809 60.1952 90.5556 57.4174 90.5556 53.9948Z"
            fill={colors[0]}
          />
        </g>
      </g>
    </svg>
  )
}
